// @flow

import React, { Fragment } from 'react';
import { I18n } from 'react-redux-i18n';
import type { CustomerProfileKpi } from '../../../../types/marketingType';

type Props = {
  title: string; // Affluent older communities
  shoppingCenterCoverage: number;
  customerProfileKpis: CustomerProfileKpi[];
  formatLabel: (string | null) => string;
  formatValue: (string | null) => string;
};

function AffluentOlderCommunities(props: Props) {
  const { customerProfileKpis, formatLabel, formatValue } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      width="594"
      viewBox="0 0 594 485.6"
    >
      <defs>
        <style>
          {`.cls-1 {
            clip-path: url(#clip-Affluent_older_communities_v2);
          }

            .cls-18, .cls-2, .cls-3 {
            fill: none;
          }

            .cls-2 {
            stroke: #5092fe;
            opacity: 0.5;
          }

            .cls-3 {
            stroke: #000;
            stroke-dasharray: 14;
          }

            .cls-4, .cls-6, .cls-9 {
            fill: #5092fe;
          }

            .cls-4, .cls-5 {
            opacity: 0.1;
          }

            .cls-7 {
            fill: #e6e6e6;
          }

            .cls-8 {
            fill: #3f3d56;
          }

            .cls-9 {
            font-size: 26px;
          }

            .cls-12, .cls-13, .cls-9 {
            font-family: "Flama-Bold, Flama";
            font-weight: 700;
          }

            .cls-10 {
            fill: #ecf3fe;
          }

            .cls-11, .cls-12 {
            fill: #362e2f;
          }

            .cls-11 {
            font-size: 13px;
            font-family: "Flama-Light, Flama";
            font-weight: 300;
          }

            .cls-12, .cls-13 {
            font-size: 20px;
          }

            .cls-13 {
            fill: #464646;
          }

            .cls-14 {
            fill: #65617d;
          }

            .cls-15 {
            fill: #fabdbd;
          }

            .cls-16 {
            fill: #fff;
          }

            .cls-17 {
            stroke: none;
          }`
          }
        </style>
        <clipPath id="clip-Affluent_older_communities_v2">
          <rect width="594" height="485.6" />
        </clipPath>
      </defs>
      <g id="Affluent_older_communities_v2" data-name="Affluent older communities – v2" className="cls-1">
        <rect className="cls-16" width="594" height="485.6" />
        <g
          id="Ellipse_45"
          data-name="Ellipse 45"
          className="cls-2"
          transform="matrix(0.966, 0.259, -0.259, 0.966, 110.887, -36.037)"
        >
          <ellipse className="cls-17" cx="244.871" cy="139.021" rx="244.871" ry="139.021" />
          <ellipse className="cls-18" cx="244.871" cy="139.021" rx="244.371" ry="138.521" />
        </g>
        <g
          id="Ellipse_44"
          data-name="Ellipse 44"
          className="cls-3"
          transform="matrix(0.966, 0.259, -0.259, 0.966, 118.267, -13.354)"
        >
          <ellipse className="cls-17" cx="241.871" cy="139.021" rx="241.871" ry="139.021" />
          <ellipse className="cls-18" cx="241.871" cy="139.021" rx="241.371" ry="138.521" />
        </g>
        <g id="Groupe_547" data-name="Groupe 547" transform="translate(1283.082 -809.421)">
          <path
            id="Tracé_869"
            data-name="Tracé 869"
            className="cls-4"
            d="M26.325,7.277c25.6-21.952,48.128,16.017,121.735,16.586S280.884-18.578,320.755,9.553,362.277,117.2,289.141,114.6s-173.166,29.351-243.47-2.927S.728,29.229,26.325,7.277Z"
            transform="translate(-851.905 1003.927) rotate(158)"
          />
          <g id="undraw_complete_task_u2c3" transform="translate(-1266 966)">
            <ellipse
              id="Ellipse_59"
              data-name="Ellipse 59"
              className="cls-5"
              cx="34.769"
              cy="5.869"
              rx="34.769"
              ry="5.869"
              transform="translate(27.87 254.741)"
            />
            <path
              id="Tracé_787"
              data-name="Tracé 787"
              className="cls-6"
              d="M164.2,447.641c2.515,3.355,5.229,7.193,7.907,11.377l.382-19.3.211.135a37.666,37.666,0,0,0-9.318-4.98l.211.117Z"
              transform="translate(-135.177 -299.888)"
            />
            <path
              id="Tracé_788"
              data-name="Tracé 788"
              className="cls-6"
              d="M146.578,432.694a19.842,19.842,0,0,0-9.854-1.021c-.159.028-.316.061-.472.094.777.834,5.307,5.758,10.914,13.18Z"
              transform="translate(-118.589 -297.783)"
            />
            <path
              id="Tracé_789"
              data-name="Tracé 789"
              className="cls-7"
              d="M214.781,516.126q.619,1.477,1.176,2.934l7.078-20.9.2.194q-1.254-2.358-2.658-4.586l-5.7,22.443Z"
              transform="translate(-166.611 -335.903)"
            />
            <path
              id="Tracé_790"
              data-name="Tracé 790"
              className="cls-6"
              d="M193.6,479.383l3.7-21.912.21.168A59.212,59.212,0,0,0,187.3,448.1l-.39,19.666Q190.65,473.661,193.6,479.383Z"
              transform="translate(-149.568 -307.974)"
            />
            <path
              id="Tracé_791"
              data-name="Tracé 791"
              className="cls-6"
              d="M107.244,488.3l-.086-.267a49.443,49.443,0,0,0,1.954,9.772l34.013,3.508c-1.776-3.274-3.609-6.346-5.388-9.146Z"
              transform="translate(-100.797 -332.396)"
            />
            <path
              id="Tracé_792"
              data-name="Tracé 792"
              className="cls-6"
              d="M112.483,514.141l-.09-.267q.516,1.683,1.157,3.4l-.092-.267,34.425,3.06q-.624-1.22-1.262-2.408Z"
              transform="translate(-103.999 -348.198)"
            />
            <path
              id="Tracé_793"
              data-name="Tracé 793"
              className="cls-6"
              d="M208.6,503.016l5.656-22.256.207.182a70.71,70.71,0,0,0-5.645-7.681l-3.749,22.209Q207.015,499.3,208.6,503.016Z"
              transform="translate(-160.67 -323.363)"
            />
            <path
              id="Tracé_794"
              data-name="Tracé 794"
              className="cls-6"
              d="M165.127,556.671l-33.5-3.226a68.411,68.411,0,0,0,5.938,6.971l-.083-.3,30.622,6.3a85.039,85.039,0,0,0-2.977-9.748Z"
              transform="translate(-115.761 -372.397)"
            />
            <path
              id="Tracé_795"
              data-name="Tracé 795"
              className="cls-6"
              d="M120.481,432.577l.079-.169c-4.605,1.045-7.857,4.179-9.646,8.714l20.492,4.63C125.338,437.723,120.55,432.649,120.481,432.577Z"
              transform="translate(-103.095 -298.38)"
            />
            <path
              id="Tracé_796"
              data-name="Tracé 796"
              className="cls-7"
              d="M218.876,528.424a84.493,84.493,0,0,1,2.678,8.8l7.977-20.008.195.2a33.5,33.5,0,0,0-2.547-8.062q-.706-1.511-1.478-2.976l-7.163,21.149C218.652,527.821,218.767,528.124,218.876,528.424Z"
              transform="translate(-168.909 -343.609)"
            />
            <path
              id="Tracé_797"
              data-name="Tracé 797"
              className="cls-6"
              d="M137.134,471.668c-2.65-4.134-5.333-7.927-7.82-11.242l-20.963-4.737-.071-.265a28.515,28.515,0,0,0-1.391,12.409Z"
              transform="translate(-100.551 -312.455)"
            />
            <path
              id="Tracé_798"
              data-name="Tracé 798"
              className="cls-6"
              d="M121.437,534.471l33.691,3.244.007-.02a114.768,114.768,0,0,0-5-11.3l-34.509-3.067q.879,2.327,1.987,4.7a41.128,41.128,0,0,0,3.822,6.438Z"
              transform="translate(-105.978 -353.98)"
            />
            <path
              id="Tracé_799"
              data-name="Tracé 799"
              className="cls-7"
              d="M320.335,553.814l.077.238a37.668,37.668,0,0,0-4-9.779l.088.225-7.6,10.13c-.2,4.188-.561,8.875-1.167,13.805Z"
              transform="translate(-223.452 -366.788)"
            />
            <path
              id="Tracé_800"
              data-name="Tracé 800"
              className="cls-7"
              d="M318.187,532.287a19.842,19.842,0,0,0-6.939-7.072c-.141-.08-.282-.154-.423-.228.067,1.138.414,7.82,0,17.112Z"
              transform="translate(-225.343 -354.994)"
            />
            <path
              id="Tracé_801"
              data-name="Tracé 801"
              className="cls-7"
              d="M293.876,645.462q-.466,1.532-.965,3.01l18.782-11.583.033.28q.538-2.616.877-5.227L293.9,645.589Z"
              transform="translate(-214.389 -420.399)"
            />
            <path
              id="Tracé_802"
              data-name="Tracé 802"
              className="cls-7"
              d="M301.671,598.225,318.5,583.707l.055.263a59.211,59.211,0,0,0-1.779-13.864L303.928,585Q303.044,591.933,301.671,598.225Z"
              transform="translate(-219.745 -382.586)"
            />
            <path
              id="Tracé_803"
              data-name="Tracé 803"
              className="cls-7"
              d="M314.993,606.584,297.941,621.3q-.94,4.19-2.093,8.064L314.4,615.827l.043.273A70.712,70.712,0,0,0,314.993,606.584Z"
              transform="translate(-216.184 -404.892)"
            />
            <path
              id="Tracé_804"
              data-name="Tracé 804"
              className="cls-6"
              d="M183.483,613.148q.022-.344.043-.708a58.847,58.847,0,0,0,7.719-11.835l-10.3-12.834q-.2-.657-.424-1.311l10.962,13.661a85.034,85.034,0,0,0,3.924-9.407l-21.681-21.779q.1-.256.206-.524l21.653,21.751.018-.011a114.777,114.777,0,0,0,3.358-11.889l-21.5-21.285q.068-.3.134-.6l21.5,21.285q.3-1.337.564-2.659l-21.439-21.83q.054-.312.1-.627L199.783,574.4c.721-3.654,1.268-7.19,1.684-10.481L180.448,541.49l.1-.261c-.5.725-.982,1.486-1.454,2.274a43.331,43.331,0,0,0-.605-7.438l-8.054,20.2a65.025,65.025,0,0,1,1.4,8.456c-.049.481-.093.966-.128,1.455l.265.266c.017.26.032.519.045.776l-.352-.354c-.017.283-.029.569-.041.854a61.235,61.235,0,0,0-1.572-11.4l-30.4-6.254c1.531,1.572,3.136,3.1,4.776,4.572a37.158,37.158,0,0,0-9.821-1.678l.237.046,4.487,11.842c3.429,2.413,7.2,5.225,11.036,8.376l-5.524-18.216q.307.273.615.544l5.51,18.169q5.378,4.455,9.958,8.983L158.4,565.6l.53.368,2.559,17.284q3.036,3.037,5.69,6.085l-1.227-18.747.513.32,1.24,18.945-.118-.051q1.045,1.213,2.026,2.426l.237-19.275.507.3-.241,19.609c.2.252.4.5.6.757a84.492,84.492,0,0,1,5.266,7.537l.114-1.754q.211.78.423,1.533l-.065,1c.236.392.465.784.69,1.176q.264.9.522,1.742-.749-1.388-1.565-2.749l-30.842,3.448c16.217,8.53,36.34,12.574,37.623,12.827-.3-1.345-.674-2.679-1.1-4,.111-.116.22-.233.33-.35.052.158.106.316.157.473-.057.061-.114.124-.171.185l.2-.094q.444,1.393.8,2.777c.094-.75.22-1.888.329-3.328,5.554-2.781,19.939-10.907,27.243-23.647l-19.086,10.42A59.428,59.428,0,0,1,183.483,613.148Zm-6.324-30.1.047-.724.484.6-.047.724Z"
              transform="translate(-117.584 -361.768)"
            />
            <path
              id="Tracé_805"
              data-name="Tracé 805"
              className="cls-7"
              d="M289.754,522.6l.169-.08c-4.214-2.132-8.716-1.793-12.987.559l12.83,16.637C290.212,529.657,289.761,522.695,289.754,522.6Z"
              transform="translate(-204.62 -352.615)"
            />
            <path
              id="Tracé_806"
              data-name="Tracé 806"
              className="cls-7"
              d="M285.834,658.914a84.5,84.5,0,0,1-3.547,8.482l18.905-10.322.025.275a33.5,33.5,0,0,0,3.18-7.834q.42-1.614.76-3.235L286.152,658C286.046,658.306,285.942,658.613,285.834,658.914Z"
              transform="translate(-207.892 -429.167)"
            />
            <path
              id="Tracé_807"
              data-name="Tracé 807"
              className="cls-7"
              d="M275.248,543.759,262.124,526.74l.114-.249a28.514,28.514,0,0,0-8.986,8.67L274.1,557.4C274.7,552.53,275.049,547.9,275.248,543.759Z"
              transform="translate(-190.137 -355.914)"
            />
            <path
              id="Tracé_808"
              data-name="Tracé 808"
              className="cls-6"
              d="M118.122,579.528a19.842,19.842,0,0,0-9.687,2.075c-.143.076-.281.156-.419.235,1,.553,6.827,3.836,14.453,9.161Z"
              transform="translate(-101.322 -388.345)"
            />
            <path
              id="Tracé_809"
              data-name="Tracé 809"
              className="cls-6"
              d="M127.932,633.268l-30.194,5.748-.165-.228a49.441,49.441,0,0,0,4.878,8.689l33.432-7.177C133.183,637.736,130.49,635.381,127.932,633.268Z"
              transform="translate(-94.936 -421.21)"
            />
            <path
              id="Tracé_810"
              data-name="Tracé 810"
              className="cls-6"
              d="M146.207,654.377q-.97-.968-1.944-1.9l-33.556,7.2-.168-.227q1.011,1.441,2.153,2.879l-.17-.226Z"
              transform="translate(-102.866 -432.956)"
            />
            <path
              id="Tracé_811"
              data-name="Tracé 811"
              className="cls-6"
              d="M179.764,691.718a85.051,85.051,0,0,0-5.844-8.35l-32.856,7.287a68.4,68.4,0,0,0,7.8,4.794l-.171-.256Z"
              transform="translate(-121.531 -451.846)"
            />
            <path
              id="Tracé_812"
              data-name="Tracé 812"
              className="cls-6"
              d="M97.343,585.926l.023-.185c-4.056,2.418-6.18,6.4-6.48,11.268l20.92-1.93C103.553,589.32,97.431,585.974,97.343,585.926Z"
              transform="translate(-90.847 -392.146)"
            />
            <path
              id="Tracé_813"
              data-name="Tracé 813"
              className="cls-6"
              d="M112.359,610.886l-21.4,1.975-.149-.23a28.514,28.514,0,0,0,2.513,12.231l29.948-5.7C119.471,616.048,115.748,613.27,112.359,610.886Z"
              transform="translate(-90.786 -407.523)"
            />
            <path
              id="Tracé_814"
              data-name="Tracé 814"
              className="cls-6"
              d="M158.552,667.681a114.781,114.781,0,0,0-8.245-9.2L116.54,666.23q1.555,1.942,3.343,3.86a41.126,41.126,0,0,0,5.625,4.941l33.044-7.328Z"
              transform="translate(-106.535 -436.627)"
            />
            <path
              id="Tracé_815"
              data-name="Tracé 815"
              className="cls-6"
              d="M164.2,447.641c2.515,3.355,5.229,7.193,7.907,11.377l.382-19.3.211.135a37.666,37.666,0,0,0-9.318-4.98l.211.117Z"
              transform="translate(-135.177 -299.888)"
            />
            <path
              id="Tracé_816"
              data-name="Tracé 816"
              className="cls-6"
              d="M146.578,432.694a19.842,19.842,0,0,0-9.854-1.021c-.159.028-.316.061-.472.094.777.834,5.307,5.758,10.914,13.18Z"
              transform="translate(-118.589 -297.783)"
            />
            <path
              id="Tracé_817"
              data-name="Tracé 817"
              className="cls-6"
              d="M214.781,516.126q.619,1.477,1.176,2.934l7.078-20.9.2.194q-1.254-2.358-2.658-4.586l-5.7,22.443Z"
              transform="translate(-166.611 -335.903)"
            />
            <path
              id="Tracé_818"
              data-name="Tracé 818"
              className="cls-6"
              d="M193.6,479.383l3.7-21.912.21.168A59.212,59.212,0,0,0,187.3,448.1l-.39,19.666Q190.65,473.661,193.6,479.383Z"
              transform="translate(-149.568 -307.974)"
            />
            <path
              id="Tracé_819"
              data-name="Tracé 819"
              className="cls-6"
              d="M107.244,488.3l-.086-.267a49.443,49.443,0,0,0,1.954,9.772l34.013,3.508c-1.776-3.274-3.609-6.346-5.388-9.146Z"
              transform="translate(-100.797 -332.396)"
            />
            <path
              id="Tracé_820"
              data-name="Tracé 820"
              className="cls-6"
              d="M112.483,514.141l-.09-.267q.516,1.683,1.157,3.4l-.092-.267,34.425,3.06q-.624-1.22-1.262-2.408Z"
              transform="translate(-103.999 -348.198)"
            />
            <path
              id="Tracé_821"
              data-name="Tracé 821"
              className="cls-6"
              d="M208.6,503.016l5.656-22.256.207.182a70.71,70.71,0,0,0-5.645-7.681l-3.749,22.209Q207.015,499.3,208.6,503.016Z"
              transform="translate(-160.67 -323.363)"
            />
            <path
              id="Tracé_822"
              data-name="Tracé 822"
              className="cls-6"
              d="M165.127,556.671l-33.5-3.226a68.411,68.411,0,0,0,5.938,6.971l-.083-.3,30.622,6.3a85.039,85.039,0,0,0-2.977-9.748Z"
              transform="translate(-115.761 -372.397)"
            />
            <path
              id="Tracé_823"
              data-name="Tracé 823"
              className="cls-6"
              d="M120.481,432.577l.079-.169c-4.605,1.045-7.857,4.179-9.646,8.714l20.492,4.63C125.338,437.723,120.55,432.649,120.481,432.577Z"
              transform="translate(-103.095 -298.38)"
            />
            <path
              id="Tracé_824"
              data-name="Tracé 824"
              className="cls-6"
              d="M218.876,528.424a84.493,84.493,0,0,1,2.678,8.8l7.977-20.008.195.2a33.5,33.5,0,0,0-2.547-8.062q-.706-1.511-1.478-2.976l-7.163,21.149C218.652,527.821,218.767,528.124,218.876,528.424Z"
              transform="translate(-168.909 -343.609)"
            />
            <path
              id="Tracé_825"
              data-name="Tracé 825"
              className="cls-6"
              d="M137.134,471.668c-2.65-4.134-5.333-7.927-7.82-11.242l-20.963-4.737-.071-.265a28.515,28.515,0,0,0-1.391,12.409Z"
              transform="translate(-100.551 -312.455)"
            />
            <path
              id="Tracé_826"
              data-name="Tracé 826"
              className="cls-6"
              d="M121.437,534.471l33.691,3.244.007-.02a114.768,114.768,0,0,0-5-11.3l-34.509-3.067q.879,2.327,1.987,4.7a41.128,41.128,0,0,0,3.822,6.438Z"
              transform="translate(-105.978 -353.98)"
            />
            <path
              id="Tracé_827"
              data-name="Tracé 827"
              className="cls-6"
              d="M320.335,553.814l.077.238a37.668,37.668,0,0,0-4-9.779l.088.225-7.6,10.13c-.2,4.188-.561,8.875-1.167,13.805Z"
              transform="translate(-223.452 -366.788)"
            />
            <path
              id="Tracé_828"
              data-name="Tracé 828"
              className="cls-6"
              d="M318.187,532.287a19.842,19.842,0,0,0-6.939-7.072c-.141-.08-.282-.154-.423-.228.067,1.138.414,7.82,0,17.112Z"
              transform="translate(-225.343 -354.994)"
            />
            <path
              id="Tracé_829"
              data-name="Tracé 829"
              className="cls-6"
              d="M293.876,645.462q-.466,1.532-.965,3.01l18.782-11.583.033.28q.538-2.616.877-5.227L293.9,645.589Z"
              transform="translate(-214.389 -420.399)"
            />
            <path
              id="Tracé_830"
              data-name="Tracé 830"
              className="cls-6"
              d="M301.671,598.225,318.5,583.707l.055.263a59.211,59.211,0,0,0-1.779-13.864L303.928,585Q303.044,591.933,301.671,598.225Z"
              transform="translate(-219.745 -382.586)"
            />
            <path
              id="Tracé_831"
              data-name="Tracé 831"
              className="cls-6"
              d="M314.993,606.584,297.941,621.3q-.94,4.19-2.093,8.064L314.4,615.827l.043.273A70.712,70.712,0,0,0,314.993,606.584Z"
              transform="translate(-216.184 -404.892)"
            />
            <path
              id="Tracé_832"
              data-name="Tracé 832"
              className="cls-6"
              d="M183.483,613.148q.022-.344.043-.708a58.847,58.847,0,0,0,7.719-11.835l-10.3-12.834q-.2-.657-.424-1.311l10.962,13.661a85.034,85.034,0,0,0,3.924-9.407l-21.681-21.779q.1-.256.206-.524l21.653,21.751.018-.011a114.777,114.777,0,0,0,3.358-11.889l-21.5-21.285q.068-.3.134-.6l21.5,21.285q.3-1.337.564-2.659l-21.439-21.83q.054-.312.1-.627L199.783,574.4c.721-3.654,1.268-7.19,1.684-10.481L180.448,541.49l.1-.261c-.5.725-.982,1.486-1.454,2.274a43.331,43.331,0,0,0-.605-7.438l-8.054,20.2a65.025,65.025,0,0,1,1.4,8.456c-.049.481-.093.966-.128,1.455l.265.266c.017.26.032.519.045.776l-.352-.354c-.017.283-.029.569-.041.854a61.235,61.235,0,0,0-1.572-11.4l-30.4-6.254c1.531,1.572,3.136,3.1,4.776,4.572a37.158,37.158,0,0,0-9.821-1.678l.237.046,4.487,11.842c3.429,2.413,7.2,5.225,11.036,8.376l-5.524-18.216q.307.273.615.544l5.51,18.169q5.378,4.455,9.958,8.983L158.4,565.6l.53.368,2.559,17.284q3.036,3.037,5.69,6.085l-1.227-18.747.513.32,1.24,18.945-.118-.051q1.045,1.213,2.026,2.426l.237-19.275.507.3-.241,19.609c.2.252.4.5.6.757a84.492,84.492,0,0,1,5.266,7.537l.114-1.754q.211.78.423,1.533l-.065,1c.236.392.465.784.69,1.176q.264.9.522,1.742-.749-1.388-1.565-2.749l-30.842,3.448c16.217,8.53,36.34,12.574,37.623,12.827-.3-1.345-.674-2.679-1.1-4,.111-.116.22-.233.33-.35.052.158.106.316.157.473-.057.061-.114.124-.171.185l.2-.094q.444,1.393.8,2.777c.094-.75.22-1.888.329-3.328,5.554-2.781,19.939-10.907,27.243-23.647l-19.086,10.42A59.428,59.428,0,0,1,183.483,613.148Zm-6.324-30.1.047-.724.484.6-.047.724Z"
              transform="translate(-117.584 -361.768)"
            />
            <path
              id="Tracé_833"
              data-name="Tracé 833"
              className="cls-6"
              d="M289.754,522.6l.169-.08c-4.214-2.132-8.716-1.793-12.987.559l12.83,16.637C290.212,529.657,289.761,522.695,289.754,522.6Z"
              transform="translate(-204.62 -352.615)"
            />
            <path
              id="Tracé_834"
              data-name="Tracé 834"
              className="cls-6"
              d="M285.834,658.914a84.5,84.5,0,0,1-3.547,8.482l18.905-10.322.025.275a33.5,33.5,0,0,0,3.18-7.834q.42-1.614.76-3.235L286.152,658C286.046,658.306,285.942,658.613,285.834,658.914Z"
              transform="translate(-207.892 -429.167)"
            />
            <path
              id="Tracé_835"
              data-name="Tracé 835"
              className="cls-6"
              d="M275.248,543.759,262.124,526.74l.114-.249a28.514,28.514,0,0,0-8.986,8.67L274.1,557.4C274.7,552.53,275.049,547.9,275.248,543.759Z"
              transform="translate(-190.137 -355.914)"
            />
            <path
              id="Tracé_836"
              data-name="Tracé 836"
              className="cls-6"
              d="M118.122,579.528a19.842,19.842,0,0,0-9.687,2.075c-.143.076-.281.156-.419.235,1,.553,6.827,3.836,14.453,9.161Z"
              transform="translate(-101.322 -388.345)"
            />
            <path
              id="Tracé_837"
              data-name="Tracé 837"
              className="cls-6"
              d="M127.932,633.268l-30.194,5.748-.165-.228a49.441,49.441,0,0,0,4.878,8.689l33.432-7.177C133.183,637.736,130.49,635.381,127.932,633.268Z"
              transform="translate(-94.936 -421.21)"
            />
            <path
              id="Tracé_838"
              data-name="Tracé 838"
              className="cls-6"
              d="M146.207,654.377q-.97-.968-1.944-1.9l-33.556,7.2-.168-.227q1.011,1.441,2.153,2.879l-.17-.226Z"
              transform="translate(-102.866 -432.956)"
            />
            <path
              id="Tracé_839"
              data-name="Tracé 839"
              className="cls-6"
              d="M179.764,691.718a85.051,85.051,0,0,0-5.844-8.35l-32.856,7.287a68.4,68.4,0,0,0,7.8,4.794l-.171-.256Z"
              transform="translate(-121.531 -451.846)"
            />
            <path
              id="Tracé_840"
              data-name="Tracé 840"
              className="cls-6"
              d="M97.343,585.926l.023-.185c-4.056,2.418-6.18,6.4-6.48,11.268l20.92-1.93C103.553,589.32,97.431,585.974,97.343,585.926Z"
              transform="translate(-90.847 -392.146)"
            />
            <path
              id="Tracé_841"
              data-name="Tracé 841"
              className="cls-6"
              d="M112.359,610.886l-21.4,1.975-.149-.23a28.514,28.514,0,0,0,2.513,12.231l29.948-5.7C119.471,616.048,115.748,613.27,112.359,610.886Z"
              transform="translate(-90.786 -407.523)"
            />
            <path
              id="Tracé_842"
              data-name="Tracé 842"
              className="cls-6"
              d="M158.552,667.681a114.781,114.781,0,0,0-8.245-9.2L116.54,666.23q1.555,1.942,3.343,3.86a41.126,41.126,0,0,0,5.625,4.941l33.044-7.328Z"
              transform="translate(-106.535 -436.627)"
            />
            <path
              id="Tracé_844"
              data-name="Tracé 844"
              className="cls-4"
              d="M244.159,109.853l-.05-.28-4.782-2.533h-.751l-.287-.55h-9.855l-2.285.55H217.73l-2.28,2.661-.023.163c-.148.952-3.446,23.332,5.256,30.453L224.311,142h2.346l-.459-.916,2.04.916h6.6l.117-.176,3.919-1.467.1-.117C239.334,139.824,247.663,129.7,244.159,109.853Z"
              transform="translate(-166.557 -99.076)"
            />
            <rect
              id="Rectangle_166"
              data-name="Rectangle 166"
              className="cls-7"
              width="3.885"
              height="10.101"
              transform="translate(61.876 33.021)"
            />
            <rect
              id="Rectangle_167"
              data-name="Rectangle 167"
              className="cls-8"
              width="6.993"
              height="194.242"
              transform="translate(60.128 56.136)"
            />
            <rect
              id="Rectangle_168"
              data-name="Rectangle 168"
              className="cls-8"
              width="10.489"
              height="6.604"
              transform="translate(58.38 52.834)"
            />
            <path
              id="Tracé_845"
              data-name="Tracé 845"
              className="cls-8"
              d="M140.276,105l6.6,6.993-2.719,5.05,5.439,1.165,5.05-1.165-3.108-5.439,6.216-6.6Z"
              transform="translate(-85.781 -64.209)"
            />
            <path
              id="Tracé_846"
              data-name="Tracé 846"
              className="cls-8"
              d="M213.17,106.845l-3.108-3.108,2.331-2.331h29.525l2.331,2.719-3.5,2.719S222.1,106.068,213.17,106.845Z"
              transform="translate(-163.725 -95.967)"
            />
            <path
              id="Tracé_847"
              data-name="Tracé 847"
              className="cls-8"
              d="M244.159,107.655l-.051-.28-4.782-2.533-2.183-1.158-12.257-.789-6.872,1.616-.284.33-2.28,2.661-.023.163c-.148.952-3.446,23.332,5.256,30.453l3.628,1.686,3.053,1.418-.707-1.418-1.162-2.319c-1.216-7.078-3.889-25.675-2.183-29.56l7.047-2.273,6.255,2.323c.431,2.793,3.22,22.377-1.667,29.358l-.1.151v2.187l4.036-1.511.1-.117C239.334,137.626,247.663,127.506,244.159,107.655Zm-5.983,29.525-2.168.816v-.148c5.361-8,1.857-29.478,1.705-30.395l-.054-.334-6.13-2.277-1.138-.423-1.313.423-6.573,2.121-.113.2c-2.5,4.479,1.787,29.54,1.97,30.6l.016.085.462.925-3.477-1.6c-7.75-6.453-5.093-27.116-4.809-29.163l2.1-2.447,3.053-.719,3.283-.773,5.4.35,6.426.416.016.008,6.227,3.294c3.085,18.006-3.994,27.893-4.883,29.043Z"
              transform="translate(-166.557 -96.878)"
            />
            <ellipse
              id="Ellipse_61"
              data-name="Ellipse 61"
              className="cls-8"
              cx="10.489"
              cy="5.439"
              rx="10.489"
              ry="5.439"
              transform="translate(53.329)"
            />
            <path
              id="Tracé_848"
              data-name="Tracé 848"
              className="cls-8"
              d="M231.278,706.406l-6.216,19.813s9.712,5.439,22.921,0l-6.216-19.813Z"
              transform="translate(-172.898 -465.935)"
            />
            <circle
              id="Ellipse_62"
              data-name="Ellipse 62"
              className="cls-6"
              cx="3.108"
              cy="3.108"
              r="3.108"
              transform="translate(60.711 27.971)"
            />
          </g>
          <path
            id="Tracé_870"
            data-name="Tracé 870"
            className="cls-6"
            d="M.315,13.793S17.13,14.814,15.149,3.03A2.867,2.867,0,0,0,13.655,0s-.03.875-1.726.577A7.872,7.872,0,0,0,10.1.489a3.811,3.811,0,0,0-2.231.917h0S3.145,3.357,1.308,11.085c0,0-1.36,1.686-1.306,2.119L2.84,11.991a5.061,5.061,0,0,1-.2-3.749s.092,3.675.637,3.6c.112-.018,1.476-.709,1.476-.709s-1.67-3.567-.409-6.157c0,0-.479,4.394.929,5.9l2-1.166S5.318,6.022,6.64,3.016c0,0-.34,4.61,1.049,6.405L9.5,8.009S7.667,4.378,8.783,1.885c0,0,.146,5.367,1.108,5.772a11.131,11.131,0,0,0,1.823-1.969s-1.254-2.636-.475-4.026c0,0,.477,3.575.869,3.6A11.868,11.868,0,0,0,13.85,1.262a8.61,8.61,0,0,1-1.36,4.22A4.748,4.748,0,0,0,14.907,4.23s-.246,1.676-2.8,1.821a10.976,10.976,0,0,1-1.652,1.907,10.4,10.4,0,0,0,4.09-.471s-1.36,1.58-4.558.861l-1.8,1.458s3.353.459,4.773-.048c0,0-1.636,1.4-5.255.379L5.768,11.3a17.847,17.847,0,0,0,4.56.4s-1.8.969-5.129-.082l-1.4.625s2.093.411,2.706.475.647.236.647.236a7.268,7.268,0,0,1-3.935-.437A18.287,18.287,0,0,0,.315,13.793Z"
            transform="translate(-897.516 1066.841) rotate(30)"
          />
          <path
            id="Tracé_871"
            data-name="Tracé 871"
            className="cls-6"
            d="M.431,18.86s22.991,1.4,20.282-14.717A3.92,3.92,0,0,0,18.671,0s-.041,1.2-2.359.789a10.763,10.763,0,0,0-2.5-.12,5.211,5.211,0,0,0-3.05,1.253h0S4.3,4.591,1.788,15.156c0,0-1.86,2.3-1.786,2.9L3.883,16.4S2.556,13.6,3.61,11.27c0,0,.126,5.025.871,4.916.153-.025,2.018-.969,2.018-.969S4.216,10.339,5.939,6.8c0,0-.655,6.008,1.27,8.067L9.94,13.269S7.272,8.234,9.08,4.124c0,0-.464,6.3,1.434,8.758l2.474-1.931s-2.5-4.965-.978-8.373c0,0,.2,7.338,1.516,7.892a15.22,15.22,0,0,0,2.493-2.693s-1.715-3.6-.65-5.505c0,0,.653,4.888,1.188,4.916,0,0,2.157-3.239,2.381-5.462a11.773,11.773,0,0,1-1.86,5.77,6.492,6.492,0,0,0,3.3-1.712s-.336,2.291-3.823,2.491A15.008,15.008,0,0,1,14.3,10.883a14.223,14.223,0,0,0,5.593-.644s-1.86,2.16-6.232,1.177L11.2,13.409s4.585.628,6.527-.066c0,0-2.237,1.912-7.185.519l-2.66,1.592A24.4,24.4,0,0,0,14.121,16s-2.458,1.324-7.013-.112L5.2,16.743s2.862.563,3.7.65.885.322.885.322a9.938,9.938,0,0,1-5.38-.6S.36,18.617.431,18.86Z"
            transform="translate(-946.341 1086.461) rotate(9)"
          />
          <path
            id="Tracé_872"
            data-name="Tracé 872"
            className="cls-6"
            d="M.228.016S12.414-.719,10.99,7.831a2.085,2.085,0,0,1-1.084,2.2s-.022-.641-1.251-.42a5.467,5.467,0,0,1-1.328.064A2.764,2.764,0,0,1,5.725,9h0S2.3,7.587.962,1.982C.962,1.982-.025.76,0,.446l2.065.879a3.7,3.7,0,0,0-.151,2.719s.067-2.665.465-2.6c.08,0,1.068.516,1.068.516S2.239,4.544,3.153,6.423c0,0-.35-3.188.673-4.281l1.446.847S3.858,5.66,4.817,7.84c0,0-.247-3.345.76-4.647L6.889,4.22S5.561,6.853,6.372,8.661c0,0,.106-3.893.8-4.188A8.044,8.044,0,0,1,8.5,5.9s-.911,1.924-.346,2.921c0,0,.346-2.594.641-2.607A8.634,8.634,0,0,1,10.057,9.1,6.223,6.223,0,0,0,9.07,6.045a3.437,3.437,0,0,1,1.754.908s-.18-1.215-2.036-1.321a7.888,7.888,0,0,0-1.2-1.382,7.511,7.511,0,0,1,2.97.34S9.57,3.444,7.251,3.947L5.968,2.889a11.068,11.068,0,0,1,3.463.035s-1.187-1.013-3.81-.276L4.208,1.805A12.849,12.849,0,0,1,7.517,1.52a5.08,5.08,0,0,0-3.723.058L2.787,1.125S4.3.827,4.75.779s.468-.17.468-.17A5.3,5.3,0,0,0,2.364.93,12.966,12.966,0,0,1,.228.016Z"
            transform="matrix(-0.208, -0.978, 0.978, -0.208, -914.232, 1059.7)"
          />
        </g>
        <path
          id="Tracé_1479"
          data-name="Tracé 1479"
          className="cls-8"
          d="M597.309,659.116c-1.376-.062-8.89,3.114-8.89,3.114s-2.381,1.329-8.462,2.181c-3.971.562-4.5-1.352-4.391-2.748a4.944,4.944,0,0,1,.3-1.338v-8.443s12.381-7.557,13.333-8.033a.954.954,0,0,1,.381-.081c1.529-.062,5.909,1.5,8.276,3.167,2.614,1.852,5.943.719,5.943.719s6.457-5.2,8.157-1.4a3.565,3.565,0,0,1,.233.681C613.433,651.973,598.69,659.159,597.309,659.116Z"
          transform="translate(-303.578 -256.597)"
        />
        <path
          id="Tracé_1480"
          data-name="Tracé 1480"
          className="cls-14"
          d="M555.439,544.143l-1.138-5.119h0s0-4.424-1.572-5.281-5.852-30.553-5.852-30.553.143-6.562-1-7.419a1.087,1.087,0,0,1,0-1.8,8.037,8.037,0,0,0-.5-2.767,13.227,13.227,0,0,1-.776-2.991s.571-2.143,0-2.71c-.4-.4.109-1.148-.824-2.643a10.727,10.727,0,0,0-2.171-2.352c-3.233-2.733-.043-33.7.833-41.652.133-1.186.214-1.857.214-1.857h7.619l.953,3.424,1.519,6.329s1,.662,1,1.519,5.99,18.971,5.99,18.971a16.444,16.444,0,0,1,1.143,2.281c.143.571,1.429,1.571,1.429,1.571a4.128,4.128,0,0,0,0,3.424c.852,1.71,3.281,8.843,2.424,12.267s-1.857,3.71-1.857,3.71-.852,2.533.571,3.476.428,2.657.428,2.657l1.857,15.981s-.143,7.143,2,9.7,2.424,8.7,2.424,8.7l-1.609.686-.291.129-.1.043s3.281,3.424,4.286,4.424S563.711,549.286,555.439,544.143Z"
          transform="translate(-285.052 -148.291)"
        />
        <path
          id="Tracé_1482"
          data-name="Tracé 1482"
          className="cls-15"
          d="M521.332,229.217a20.106,20.106,0,0,0-2.857,5.086,16.944,16.944,0,0,0-.567,10.8s-20.638-4.567-18.638-6.848c1.21-1.386,2.21-6.714,2.81-10.7.39-2.6.614-4.619.614-4.619S527.513,221.136,521.332,229.217Z"
          transform="translate(-263.549 -35.075)"
        />
        <path
          id="Tracé_1483"
          data-name="Tracé 1483"
          className="cls-8"
          d="M513.315,670.049a6.129,6.129,0,0,1-2.076,3.586c-1.571,1.329-16.548,1.8-19.591.667s-12.743-1.571-15.171-1.667-3.371-2.329-3.9-3.424a3.292,3.292,0,0,1,.21-1.833,24.326,24.326,0,0,1,2.314-5.2,5.59,5.59,0,0,0,.6-1.981c.129-.71.214-1.333.214-1.333,6.51,4.438,15.071-3.1,15.071-3.1a1.742,1.742,0,0,1,1.048-.191c1.638.2,3.424,2.348,3.424,3.3,0,1.157,4.514,3.333,4.514,3.333,1.286,1.476,6.99,4.233,6.99,4.233s3.9.1,5.614,1.567A2.267,2.267,0,0,1,513.315,670.049Z"
          transform="translate(-249.603 -262.769)"
        />
        <path
          id="Tracé_1484"
          data-name="Tracé 1484"
          className="cls-14"
          d="M515.085,443.746c-.619,9.562-5.438,42.281-5.438,42.281s-2.71,11.981-3.281,12.41-4.133,2.857-4.133,2.857-.143,5.567-1.286,7.143S499.375,514,499.375,514s-1.852,7.986-2.424,11.981a57.627,57.627,0,0,1-2.567,9.414v8.7c-13.171,13.51-16.414,4.229-17.176.038a15,15,0,0,1-.229-1.752l7.419-45.076s1.567-2.143,1.281-3.281a4.124,4.124,0,0,1,.571-2.571l-.024-2.567s1.738-2.281,0-3.567,0-10.986,0-10.986-1.971-5.562-.952-7.143,0-4.138.71-5.567,0,0-2.567-3.852c-1.343-2.01-2.486-5.652-3.276-8.671-.724-2.776-1.148-5.024-1.148-5.024s35.238-4.99,36.1-2.857A9.63,9.63,0,0,1,515.085,443.746Z"
          transform="translate(-251.945 -150.227)"
        />
        <path
          id="Tracé_1485"
          data-name="Tracé 1485"
          className="cls-15"
          d="M529.547,203.62a13.81,13.81,0,1,1-3.733-9.424,13.81,13.81,0,0,1,3.733,9.424Z"
          transform="translate(-265.012 -17.822)"
        />
        <path
          id="Tracé_1486"
          data-name="Tracé 1486"
          className="cls-6"
          d="M515.239,337.714s-15.871,2.567-16.824,3.9-8.1,1.71-12.381,2.281-11.981-.667-12.552-1.048c-3.333-2.224-1.714-28.338-.286-31.576s.952-21.3-.381-28.529.667-16.262.667-16.262,2-6.371,1.619-7.7,1.9-4.181,1.9-4.181,3.519-5.8,5.324-6.667a2.562,2.562,0,0,0,1.362-1.633,14.463,14.463,0,0,0,.352-3.5,1.975,1.975,0,0,1,2-1.9c5.424.852,18.167,8.843,18.167,8.843-.476,1.8,2.567,6.943,2.567,6.943.052.081.1.167.143.257,3.333,6.281,5.757,25.514,5.757,25.514s.167,9.186.138,15.948a58.248,58.248,0,0,1-.238,6.876c-.276,1.3.271,7.31.829,13.033.381,3.957.771,7.771.891,9.79C514.606,333.052,515.239,337.714,515.239,337.714Z"
          transform="translate(-249.085 -45.568)"
        />
        <path
          id="Tracé_1487"
          data-name="Tracé 1487"
          className="cls-6"
          d="M520.3,256.948c-3.514-1.376-9.643-4.029-12.41-6.724s-7.843-3.6-10.814-3.919a14.463,14.463,0,0,0,.352-3.5,1.975,1.975,0,0,1,2-1.9c5.424.852,18.167,8.843,18.167,8.843-.476,1.8,2.567,6.943,2.567,6.943C520.213,256.771,520.256,256.857,520.3,256.948Z"
          transform="translate(-262.473 -45.573)"
        />
        <path
          id="Tracé_1488"
          data-name="Tracé 1488"
          className="cls-15"
          d="M507.21,330.181l1.71,5.924,6.667,10.433s3.233,3.519,3.233,4,11.9,9.7,16.929,12.267,11.429,4.676,11.9,6.524,3.333,15.638,11.429,11.167-2.281-14.552-2.281-14.552l-6.667-5.9S535.91,348.914,534.7,345.209s-5.967-6.943-5.967-6.943l-3.333-6.09-12.457-7.986Z"
          transform="translate(-267.78 -89.201)"
        />
        <path
          id="Tracé_1489"
          data-name="Tracé 1489"
          className="cls-6"
          d="M493.858,269.343s-11.6,5.329-7.986,13.81,11.5,24.091,11.5,24.091-.952-5.448,1.143-5.924,15.31,2,15.31,2-3.043-6.467-2.381-10.081S506.415,266.2,493.858,269.343Z"
          transform="translate(-256.237 -60.32)"
        />
        <path
          id="Tracé_1490"
          data-name="Tracé 1490"
          className="cls-16"
          d="M498.261,190.394c1.51.419,2.567,2.148,4.133,2.081,1.148-.052,2-1.057,2.629-2.014a29.386,29.386,0,0,0,2.629-4.886,10.738,10.738,0,0,1,1.429-2.748,2.957,2.957,0,0,1,2.7-1.19c1.1.214,1.848,1.243,2.857,1.79,1.8,1,4.038.276,5.962-.476.952-.362,2-.886,2.157-1.867.114-.69-.281-1.386-.191-2.081a4.706,4.706,0,0,1,.952-1.752c.348-.571.548-1.4.057-1.857-.357-.333-.914-.31-1.371-.476-1.138-.443-1.429-1.971-2.443-2.657-1.1-.738-2.557-.243-3.881-.181-1.9.086-3.681-.79-5.448-1.49s-3.781-1.238-5.529-.5a12.566,12.566,0,0,0-2.738,1.981,12.267,12.267,0,0,1-5.986,2.524,6.137,6.137,0,0,0-3.1.838,3.974,3.974,0,0,0-1.024,3.757,17.715,17.715,0,0,1,.571,4.024c-.171,2.148-1.776,3.914-2.31,6a2.31,2.31,0,0,0,.233,2.024,4.239,4.239,0,0,0,1.081.781,4.162,4.162,0,0,1,1.862,3c.071.614,0,1.238.1,1.848a3.643,3.643,0,0,0,4.214,2.857,10.824,10.824,0,0,0-.552-4.738C496.694,193.437,494.561,189.384,498.261,190.394Z"
          transform="translate(-258.864 -8.295)"
        />
        <ellipse
          id="Ellipse_60"
          data-name="Ellipse 60"
          className="cls-5"
          cx="72.769"
          cy="9.381"
          rx="72.769"
          ry="9.381"
          transform="translate(188.292 396.614)"
        />
        <ellipse
          id="Ellipse_63"
          data-name="Ellipse 63"
          className="cls-5"
          cx="4.719"
          cy="1.333"
          rx="4.719"
          ry="1.333"
          transform="translate(280.348 415.376)"
        />
        {
          customerProfileKpis.length >= 1
          && (
            <Fragment>
              <path
                id="Tracé_692"
                data-name="Tracé 692"
                className="cls-10"
                d="M15327.3-506.871c19.628-12.592,71.639-15.749,86.359,20.145s-55.61,41.515-84.07,36.281-77.2-2.951-57.246-27.491S15307.674-494.28,15327.3-506.871Z"
                transform="translate(-15236 595.74)"
              />
              <g id="Groupe_526" data-name="Groupe 526" transform="translate(-834 -1570.08)">
                <text id="Household_size" data-name="Household size" className="cls-11" transform="translate(883 1673)">
                  <tspan x="0" y="0">{formatLabel(customerProfileKpis[0].label)}</tspan>
                </text>
                <text id="Below_average" data-name="Below average" className="cls-12" transform="translate(863 1696)">
                  <tspan x="0" y="0">{formatValue(customerProfileKpis[0].value)}</tspan>
                </text>
              </g>
            </Fragment>
          )
        }
        {
          customerProfileKpis.length >= 2
          && (
            <Fragment>
              <path
                id="Tracé_693"
                data-name="Tracé 693"
                className="cls-10"
                d="M15385.162-506.871c-26.1-12.592-95.252-15.749-114.824,20.145s73.939,41.515,111.779,36.281S15411.26-494.28,15385.162-506.871Z"
                transform="translate(-15001.621 -1879.177) rotate(9)"
              />
              <g id="Groupe_529" data-name="Groupe 529" transform="translate(-870.026 -1813.721)">
                <text
                  id="Children_at_home"
                  data-name="Children at home"
                  className="cls-11"
                  transform="translate(1028 1847)"
                >
                  <tspan x="0" y="0">{formatLabel(customerProfileKpis[1].label)}</tspan>
                </text>
                <text
                  id="Below_average-2"
                  data-name="Below average"
                  className="cls-12"
                  transform="translate(1015 1870)"
                >
                  <tspan x="20" y="0">{formatValue(customerProfileKpis[1].value)}</tspan>
                </text>
              </g>
            </Fragment>
          )
        }
        {
          customerProfileKpis.length >= 3
          && (
            <Fragment>
              <path
                id="Tracé_694"
                data-name="Tracé 694"
                className="cls-10"
                d="M15367.854-506.871c32.975-12.592,51.66,61.66,3.846,56.426s-129.705-2.951-96.18-27.491S15334.877-494.28,15367.854-506.871Z"
                transform="matrix(-0.998, 0.07, -0.07, -0.998, 15678.096, -1501.188)"
              />
              <g id="Groupe_528" data-name="Groupe 528" transform="translate(-761.802 -1717.832)">
                <text
                  id="Likelihood_to_move"
                  data-name="Likelihood to move"
                  className="cls-11"
                  transform="translate(1121 1754)"
                >
                  <tspan x="0" y="0">{formatLabel(customerProfileKpis[2].label)}</tspan>
                </text>
                <text id="Above_average" data-name="Above average" className="cls-12" transform="translate(1113 1777)">
                  <tspan x="0" y="0">{formatValue(customerProfileKpis[2].value)}</tspan>
                </text>
              </g>
            </Fragment>
          )
        }
        {
          customerProfileKpis.length >= 4
          && (
            <Fragment>
              <path
                id="Tracé_695"
                data-name="Tracé 695"
                className="cls-10"
                d="M15356.038-457.452c-19.628,12.592-71.639,15.749-86.359-20.145s.469-56.89,84.07-36.281S15375.666-470.043,15356.038-457.452Z"
                transform="translate(-14826.717 618.173)"
              />
              <g id="Groupe_527" data-name="Groupe 527" transform="translate(-674.716 -1553.648)">
                <text
                  id="Home_ownership"
                  data-name="Home ownership"
                  className="cls-11"
                  transform="translate(1122 1676)"
                >
                  <tspan x="0" y="0">{formatLabel(customerProfileKpis[3].label)}</tspan>
                </text>
                <text
                  id="Private_renters"
                  data-name="Private renters"
                  className="cls-12"
                  transform="translate(1124 1699)"
                >
                  <tspan x="0" y="0">{formatValue(customerProfileKpis[3].value)}</tspan>
                </text>
              </g>
            </Fragment>
          )
        }
        {
          customerProfileKpis.length >= 5
          && (
            <Fragment>
              <path
                id="Tracé_696"
                data-name="Tracé 696"
                className="cls-10"
                d="M15326.651-507.324c18.877-11.936,68.9-14.93,83.053,19.1s-53.48,39.354-80.852,34.392S15307.776-495.388,15326.651-507.324Z"
                transform="translate(-14851.034 726.7)"
              />
              <g id="Groupe_524" data-name="Groupe 524" transform="translate(25.021 -1312.12)">
                <text id="Average_income" data-name="Average income" className="cls-11" transform="translate(484 1553)">
                  <tspan x="-51.248" y="0">{formatLabel(customerProfileKpis[4].label)}</tspan>
                </text>
                <text id="_34_722" data-name="€ 34,722" className="cls-13" transform="translate(494 1576)">
                  <tspan x="-42.6" y="0">{formatValue(customerProfileKpis[4].value)}</tspan>
                </text>
              </g>
            </Fragment>
          )
        }
        {
          customerProfileKpis.length >= 6
          && (
            <Fragment>
              <path
                id="Tracé_697"
                data-name="Tracé 697"
                className="cls-10"
                d="M15305.651-504.652c20.093-1.286,54.209-.733,54.591,17.925s-28.652,35.3-49.364,32.208-45.294-12.775-41.616-31.164S15285.559-503.366,15305.651-504.652Z"
                transform="translate(-14852.348 817.189)"
              />
              <g id="Groupe_525" data-name="Groupe 525" transform="translate(-106.5 -1308.632)">
                <text id="Average_age" data-name="Average age" className="cls-11" transform="translate(560 1634)">
                  <tspan x="-39.187" y="0">{formatLabel(customerProfileKpis[5].label)}E</tspan>
                </text>
                <text id="_24-44" data-name="24-44" className="cls-12" transform="translate(560 1657)">
                  <tspan x="-27.051" y="0">{formatValue(customerProfileKpis[5].value)}</tspan>
                </text>
              </g>
            </Fragment>
          )
        }
        <text
          id="Affluent_older_communities"
          data-name="Affluent older communities"
          className="cls-9"
          transform="translate(50 470.579)"
          width="60px"
        >
          <tspan x="0" y="-15">{props.title.split(' ').slice(0, 2).join(' ')}</tspan>
          <tspan x="0" y="10">{props.title.split(' ').slice(2).join(' ')}</tspan>
        </text>
        <g id="Groupe_coverage" data-name="Groupe coverage" transform="translate(402 470.579)">
          <text
            id="Shopping_center_coverage_data"
            data-name="Coverage shopping center"
            className="cls-9 dominant-profiles-coverage"
            transform="translate(0 -26)"
          >
            <tspan x="0" y="0">{props.shoppingCenterCoverage}</tspan>
          </text>
          <text
            id="Shopping_center_coverage"
            data-name="shopping center"
            className="cls-11"
            transform="translate(0 0)"
          >
            <tspan x="0" y="0">{I18n.t('MKT_PAGE.dominantCustomer.SHOPPING_CENTER_COVERAGE')}</tspan>
          </text>
        </g>
      </g>
    </svg>
  );
}

export default AffluentOlderCommunities;

